import React from 'react';
import { usePage } from "@inertiajs/react";
import { reduce } from "lodash";
import SelectMulti from "@/User/Components/SelectMulti";

const BudgetSelect = ({ id, values, handleChange }) => {
    const { prefectureList } = usePage().props;

    const optionList = reduce((prefectureList), (result, item) => {
        return {
            ...result,
            [item.id]: item.prefecture_name,
        };
    }, {});

    return (
        <SelectMulti id={id} options={optionList} value={values} handleChange={handleChange} placeholder="地域を選ぶ" />
    );
};

export default BudgetSelect;
